import React, { FunctionComponent } from 'react';
import { Box, DialogTitleProps, DialogTitle as MuiDialogTitle, Typography } from '@material-ui/core';
import dialogTitleStyles from './dialogTitleStyles';

export type TDialogTitleProps = DialogTitleProps & { title: string | React.ReactNode };

const DialogTitle: FunctionComponent<TDialogTitleProps> = ({ title, className, children, ...rest }) => {
  const styles = dialogTitleStyles();

  return (
    <Box className={className}>
      <MuiDialogTitle disableTypography={true} {...rest}>
        <Typography variant={'h3'} className={styles.title}>
          {title}
        </Typography>
      </MuiDialogTitle>

      {children && (
        <Box pl={3} pr={3} pb={2}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default DialogTitle;
